import React,{Component}   from 'react';

import zhiji1     from './assets/img/zhiji1.png';
import chengwei2  from './assets/img/chengwei2.png';
import nenglifen1 from './assets/img/nenglifen1.jpg';
import nenglifen2 from './assets/img/nenglifen2.jpg';
import nenglifen3 from './assets/img/nenglifen3.jpg';
import nenglifen4 from './assets/img/nenglifen4.jpg';
import shouru     from './assets/img/shouru.png';
import jinengfenlei21     from './assets/img/jinengfenlei21.png';
import chengwei22     from './assets/img/chengwei22.png';
import zhijitiaozhengtiaojiantu    from './assets/img/zhijitiaozhengtiaojiantu.png';
class Section2 extends Component {
    
    showDrawer = (data) => {
        this.props.enclosureShow(data.target.id,data.target.title)
    }

    render(){
        return(
            <div>
            {/*第二章start*/}
            <h1 name="0-1" className="point" id="0-1">第二章
                云豪集团员工职业发展路径及收入构成（积分制）</h1>
            <h2 name="0-1-0" className="point" id="0-1-0">一、
            云豪集团技能职级分类图和岗位称谓划分图</h2>
             <div style={{ textIndent: '2em' }}>
                 {/* <h3>1、 技能级别分类图</h3>
                <div>
                    <img src={zhiji1} alt="" style={{
                        width  : '750px',
                        display: 'block',
                        margin : '0 auto'
                    }}/>
                    <br/><br/>
                </div> */}
                <h3>2、 岗位称谓划分图</h3>
                <div>
                    <img src={chengwei2} alt="" style={{
                        width  : '800px',
                        display: 'block',
                        margin : '0 auto'
                    }}/>
                    <br/>
                    <p>备注：此图为云豪集团技能职级和岗位称谓划分图，非管理流程。</p>
                    <br/>
                </div>
            </div>
            <h2 name="0-1-1" className="point" id="0-1-1">二、
            监管/支持/营销机构技能职级与岗位称谓说明</h2>
            <h3>一、 监管/支持机构各岗位称谓与技能级别说明</h3>
            <div style={{ textIndent: '2em' }}>
                <p>1、云豪《技能级别分类表》中的纵向坐标为“职级”，横向坐标为“职档”，“职级”与云豪毕业证或技师证相关联，“职档”与云豪结业证相关联，获取的结业证越多职档越高。</p>
                <p>2、通过面试员工称为“试用期员工”或“见习生”，技能职级为1级。。</p>
                <p>3、3个月试用期满后经过考核可转正的员工，转正3个月以内考取初级技师证或初级毕业证是员工转正的必要条件。</p>
                <p>4、营销机构服务板块有三个称谓：队长、组长、班长。管理人员＞3人为“队长”，管理人员≤3人为“组长”，创业空间老板为“班长”。“队长、组长”有资格做“创业空间”合伙人，“创业空间”的负责人就是集团公司的合作人，“创业空间”是独立核算单元，负责人的称谓为“班长”。合格技师可随时申请“创业空间”的班长。</p>
                <p>5、总监级人员，行政级别分别一、二、三级，三级为最高级别，因此云豪集团关于总监级从行政级别从低到高共分为五个层级：副总监、副总监主持工作、一级总监、二级总监、三级总监。</p>
                
                <br/>
            </div>
            {/* <h3>二、 营销机构各岗位称谓与技能职级说明</h3> */}
            <div style={{ textIndent: '2em' }}>
                {/* <p>1、通过面试的员工或实习生称为“试用/实习期员工”，技能职级为1级。</p>
                <p>2、3个月试用期满后经过考核可转正的员工称为“基层技术员”，技能职级为2级。</p>
                <p>3、“基层技术员”满半年后有资格晋升为“技师”，“技师”技能职级为3级。</p>
                <p>4、营销机构服务板块有三个称谓：队长、组长、班长。管理人员＞3人为“队长”，管理人员≤3人为“组长”，创业空间老板为“班长”。“基层技术员”工作满一年后有资格竞聘“队长、组长”职位，队长、组长技能职级为4级，是云豪集团“基层管理人员”。</p>
                <p>5、“队长、组长”有资格做“创业空间”合伙人，“创业空间”的负责人就是集团公司的合作人，“创业空间”是独立核算单元，负责人的称谓为“班长”。</p>
                <p>6、合格技师可随时申请“创业空间”的班长。-6级，各部室经理技能级别为7-8级。</p>
                <p>7、“队长和组长”岗位工作满一年后有资格竞聘中层以上职位。</p>
                <p>8、技能职级5级以上（含5级）岗位为“中高层管理人员”。</p>
                <p>9、营销机构各品牌部/事业部/分公司负责人称谓为总监或副总监，副总监技能级别为5-6级，总监技能级别为7-8级。</p>
                <p>10、总监级人员，小写数字代表的只是技能级别，行政级别分别一、二、三级，三级为最高级别，因此云豪集团关于总监级从行政级别从低到高共分为五个层级：副总监、副总监主持工作、一级总监、二级总监、三级总监。</p>
                <p>11、营销机构各管理公司/管理中心的负责人称为“总经理”或“副总经理”，为集团的“高级管理人员”，副总经理技能级别为7-8级，总经理技能级别为8-9级。</p>
                <br/><br/> */}
            </div>
            <h2 name="0-1-2" className="point" id="point15">三、监管/支持/营销机构技能职级划分和调整的必要条件如下：</h2>
            {/* <div style={{ textIndent: '2em' }}>
                <h3>一、云豪集团技能级别分类图和岗位称谓划分图</h3>
                <h4>1、技能级别分类图</h4>
                <br/>
                <img src={jinengfenlei21} alt="" style={{  width  : '700px', display: 'block', margin : '0 auto'}}/>
                <br/>
                <h4>2、岗位称谓划分图</h4>
                <br/>
                <img src={chengwei22} alt="" style={{  width  : '700px', display: 'block', margin : '0 auto'}}/>
                <br/>
            </div> */}
            {/* <p>1、基层专员/技术员对应2-3级，必须具有初级证；</p> */}
            {/* <p>2、主管（队长/组长/班长）对应4级，必须具有高级证；</p>
            <p>3、科级/副科级对应5级，至少具有高级证；</p>
            <p>4、副经理/副总监对应5-6级，支持监管机构至少具有高级毕业证，营销机构以维修业务为主的必须具有讲师证和中级毕业证，其他非维修岗位的必须具有与本岗位工作特性相匹配的高级技师证和中级毕业证。</p>
            <p>5、各部室经理/营销机构副总经理/总监对应7-8级，支持监管机构至少具有教练证，营销机构以维修业务为主的必须具有讲师证和教练证，其他非维修岗位的必须具有与本岗位工作特性相匹配高级技师证和教练证。</p>
            <p>6、集团副总裁/总裁助理/营销机构总经理对应8-9级，至少具有教练证和高级技师证，营销机构以维修业务为主的必须具有教练证和讲师证。</p>
            <br/>
                <img src={zhijitiaozhengtiaojiantu} alt="" style={{  width  : '700px', display: 'block', margin : '0 auto'}}/>
                <br/> */}
            <h2 name="0-1-3" className="point" id="0-1-3">四、
                收入构成——积分管理细则</h2>
            <div style={{ textIndent: '2em' }}>
                <h3 name="0-1-3-0" className="point" id="0-1-3-0">1、
                    待更新</h3>
                {/* <h3 style={{ padding: '10px 0' }}>
                    <strong>收入构成：职级工资+固定积分收入+动态积分收入+突出贡献补贴+年终奖金+业绩提成+创业空间+承包收益+合伙人分红+年薪+实股</strong>
                </h3> */}
                <div style={{ textIndent: '2em' }}>
                    {/* <p><strong>说明：</strong>依照云豪集团技能职级划分图一一对应，每个横向职档为200元，每个纵向职级为500元。
                    </p> */}
                </div>
                <h3 name="0-1-3-1" className="point"
                    id="0-1-3-1">2、固定积分收入（能力分）</h3>
                <div style={{ textIndent: '2em' }}>
                    <p>为了体现云豪集团每个员工不同特质的价值，把员工的固有能力转化为积分累加，不同能力可以叠加，也叫固定积分。固定积分与收入对应，是每个月固定收入的一部分。以此鼓励员工努力学习，不断提升，创新发展，一职多能。</p>
                    <br/>
                    <h4>2.1、 能力分的设定内容</h4>
                    <div>
                        <img src={nenglifen1} alt="" style={{  width  : '893px', display: 'block', margin : '0 auto'}}/>
                        <img src={nenglifen2} alt="" style={{  width  : '850px', display: 'block', margin : '0 auto'}}/>
                        <img src={nenglifen3} alt="" style={{  width  : '850px', display: 'block', margin : '0 auto'}}/>
                        <img src={nenglifen4} alt="" style={{  width  : '850px', display: 'block', margin : '0 auto'}}/>
                    </div>
                    <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure21' title="《云豪学院课程级证书分类导图》" onClick={(value)=>this.showDrawer(value)}>《云豪学院课程级证书分类导图》</a></div>
                    <br/>
                    <h4>2.2、 固定得分标准</h4>
                    <div style={{ textIndent: '2em' }}>
                        <h4>2.2.1 行业类技术证书</h4>
                        <div style={{ textIndent: '2em' }}>
                            <p>每获得一个汽车行业相关的证书，可获得200分。有级别分类的证书，每提升一级另加50分。</p>
                            <p>其他行业类技术证书，可获得100分。有级别分类的证书，每提升一级另加30分。</p>
                            <p>注:公司认可非汽车行业证书，但不鼓励员工恣意获取。</p>
                        </div>
                        <h4>2.2.2 国家高级技术证书</h4>
                        <div style={{ textIndent: '2em' }}>
                            <p>每获得一个国家高级技术证书，可获得500分。有级别分类的证书，每提升一级另加100分。</p>
                            <p>高级工程师初级（助理工程师），可获得300分，每提升一级另加200分。</p>
                        </div>
                        <h4>2.2.3 云豪学院颁发的证书</h4>
                        <div style={{ textIndent: '2em' }}>
                            <p>初级证：100分</p>
                            <p>中级证：200分</p>
                            <p>高级证：300分</p>
                            <p>讲师证/教练证：400分</p>
                            <p>以上证书积分不累加，取最高积分项，所获取的证书由云豪学院每年复审，复审合格继续有效。</p>
                        </div>
                        <h4>2.2.4 厂家颁发的证书</h4>
                        <div style={{ textIndent: '2em' }}>
                            <p>此类证书需云豪学院再次考核，专业内容要与云豪学院工匠证书相匹配，相同专业内容的证书不重复计入。</p>
                        </div>
                        <h4>2.2.5 特长</h4>
                        <div style={{ textIndent: '2em' }}>
                            <p>每具备一个特长，可获得50分。</p>
                        </div>
                        <h4>2.2.6 学历</h4>
                        <div style={{ textIndent: '2em' }}>
                            <p>获得毕业证书可获得相应得分，高中/中专/技校毕业证基础分100分，大专另加50分，本科另加80分，研究生另加100分，博士生另加200分。</p>
                        </div>
                        <h4>2.2.7 岗位</h4>
                        <div style={{ textIndent: '2em' }}>
                            <p>担任云豪集团管理层岗位可获得相应得分，主管/班组长100分，每提升一级另加100分。</p>
                        </div>
                        <h4>2.2.8 荣誉</h4>
                        <div style={{ textIndent: '2em' }}>
                            <p>每获得一个荣誉可获得相应得分。团员50分；党员200分；退伍军人100分；地方政府给予的荣誉100分（一年有效）；云豪集团优秀员工按奖金总额平均分配到每月（一年有效）；云豪集团优秀员工按奖金总额平均分配到每月（一年有效）；厂家给予的荣誉300分（一年有效）。</p>
                        </div>
                        <h4>2.2.9 工龄</h4>
                        <div style={{ textIndent: '2em' }}>
                            <p>工作满一个工龄年可获得100分，每增加一年增加50分。</p>
                            <p>注：以上每分对应每月固定收入1元。各种证书及材料由本人提报，总监通过，技术中心和云豪学院鉴定，人力资源部审核备案，最后生效。以上各条需严格审查。</p>
                        </div>
                    </div>
                    <h4>2.3、 固定得分鉴定方式</h4>
                    <div style={{ textIndent: '2em' }}>
                        <p>2020年固定积分项要通过鉴定转化为有效价值的证书可获得固定积分。</p>
                        <p>如各类证书在本公司本年度被鉴定为有贡献价值，或在本公司职位有运用价值的，则有积分与工资挂钩；如各类证书在本公司被鉴定为无贡献价值，无运用价值，以及员工不正当渠道恣意获取所得证书，一律不算积分不与工资挂钩；</p>
                    </div>
                    <h4>2.4、 固定得分鉴定审核结果</h4>
                    <div style={{ textIndent: '2em' }}>
                        <p>每分对应每月固定收入1元。各种证书及材料由本人提报，总监通过，技术中心和云豪学院鉴定，人力资源部审核备案，最后生效。以上各条需严格审查。</p>
                        <p>特殊说明：每年董事会根据行业技术证书的贡献价值、使用价值进行评定，具体评定结果以董事会为准。</p>
                    </div>
        
                </div>
                <h3 name="0-1-3-2" className="point" id="0-1-3-2">3、
                    动态积分收入（结果分）</h3>
                <h4 name="0-1-3-2-0" className="point" id="0-1-3-2-0">3.1、
                    动态积分的设定内容 </h4>
                    <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure22' title="《动态积分的设定内容》" onClick={(value)=>this.showDrawer(value)}>《动态积分的设定内容》</a></div>
                {/* <div><img src={sheding1} alt="" style={{
                    width  : '900px',
                    display: 'block',
                    margin : '0 auto'
                }}/></div>
                <div><img src={sheding2} alt="" style={{
                    width  : '900px',
                    display: 'block',
                    margin : '0 auto'
                }}/></div> */}
                <br/>
                <h4 name="0-1-3-2-1" className="point" id="0-1-3-2-1">3.2、
                    动态积分收入说明</h4>
                <h4>3.2.1、 目的</h4>
                <div
                    style={{ textIndent: '2em' }}>动态积分的目的是集中体现云豪集团“笃实”“诚信”“创新”“共赢”的价值观，充分挖掘每位员工的潜能，鼓励每一个人创造更多。
                </div>
                <h4>3.2.2 实施原则</h4>
                <div style={{
                    textIndent: '2em',
                    padding   : '10px 0'
                }}>动态积分有奖有罚，动态积分有可能有正有负，它与固定积分的总和构成了当月员工的部分收入。动态积分用过即清零不再重复与收入挂钩，但是“积分痕迹”会长期有效。
                </div>
                <h4>3.2.3 “积分痕迹”的重要性</h4>
                <div style={{ textIndent: '2em' }}>
                    <p>“积分痕迹”的累加是年底评优的重要依据。</p>
                    <p>“积分痕迹”是岗位晋升的重要依据。</p>
                    <p>“积分痕迹”是福利排序的重要依据（如房、车、境内/境外旅游、子女入学等）。</p>
                    <p>“积分痕迹”是进入集团公司股东会、合伙人、微老板的重要依据。</p>
                    <p>“积分痕迹”是内勤人员年终奖金的重要依据。</p>
                    <p><strong>注：</strong></p>
                    <p>
                        <strong>境外旅游：每年集团公司将会免费奖励5-8个名额（可携带1名家属）赴北欧或东南亚旅游；</strong>
                    </p>
                    <p>
                        <strong>境内旅游：奖励8-10个名额（可携带1名家属）赴新疆或国内旅游胜地旅游；</strong>
                    </p>
                    <p><strong>主要奖励对象为获得上一年度集团公司各级别优秀员工。</strong></p>
                </div>
                <h4>3.2.4 评优依据</h4>
                <div style={{ textIndent: '2em' }}>
                    <p>1) 无违规违纪行为（一票否决制，以监察部记录为准）</p>
                    <p>2)
                        规定作业保质保量完成。（周/月报、晨夕会/周会/月会及对云豪《员工手册》的认知，以上内容以办公室的核查记录为准）（权重20%）</p>
                    <p>3) 考勤（以人力资源部记录为准）（权重5%）</p>
                    <p>4) 业绩+动态积分+固定积分（权重35%）</p>
                    <p>5) 直接领导的测评和同事他评（以九级能力划分法为基准）（权重25%）</p>
                    <p>6) 第三方社会荣誉 （权重15%）</p>
                </div>
                <br/>
                <h3 name="0-1-3-3" className="point" id="0-1-3-3">4、
                    员工收入一览表</h3>
                <div><img src={shouru} alt="" style={{
                    width  : '750px',
                    display: 'block',
                    margin : '0 auto'
                }}/></div>
            </div>
            <br/><br/><br/>
        </div>
        )
    }
}



export default Section2;